<template>
  <el-container>
    <div class="bck">
<!--      <el-header style="position: absolute;z-index: 2;right: 0;width: 100%;padding: 0 0px;border: none;">-->
<!--        <el-menu mode="horizontal" style="background:rgba(12,47,86,0.5)">-->
<!--          <el-menu-item style="float: right;font-size: 20px">系统登录</el-menu-item>-->
<!--          <el-menu-item style="margin-left: 20%;font-size: 22px;color: white" index="7">-->
<!--            <img style="width: 100%;height: 65px;" src="../static/img/index/LOGO.png" />-->
<!--          </el-menu-item>-->
<!--        </el-menu>-->
<!--      </el-header>-->

      <div class="position-relative">
        <div class="login">
          <div style="" class="text-h6 q-mb-lg">
            账号登录
          </div>
          <el-form>

            <el-form-item>
              <el-input type="text" v-model.trim="account.account" placeholder="用户名">
                <i slot="suffix" class="ace-icon fa fa-user"></i>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-input type="password" v-model.trim="account.password" placeholder="密码">
                <i slot="suffix" class="ace-icon fa fa-lock"></i>
              </el-input>
            </el-form-item>

            <!-- <div class="space"></div>-->
            <div v-if="isShow" class="drag q-mb-md" ref="dragDiv">
              <div class="drag_bg"></div>
              <div class="drag_text">{{confirmWords}}</div>
              <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;">
              </div>
            </div>

            <el-button size="medium" v-on:click="login()" type="primary" style="width: 100%">
              登录
            </el-button>
            <div class="q-mt-sm">
              <el-checkbox v-model="remember">记住密码</el-checkbox>
            </div>

          </el-form>
        </div><!-- /.widget-main -->
      </div><!-- /.widget-body -->
    </div>

  </el-container>

</template>

<script>
import {aesEncrypt,aesDecrypt} from '../utils/mycrypto'
import tools from '../utils/tools'
import {account} from '../api/account'

export default {
  name: 'login',
  data() {
    return {
      account: {},
      remember: true,
      item: '我们的产品',

      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveStata: false /*触发拖动状态  判断*/,
      maxwidth: '' /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: '拖动滑块验证' /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      //控制滑块显示及隐藏
      isShow: true,
      fullwidth: 0
    }
  },
  mounted: function () {
    let that = this
    that.maxwidth = that.$refs.dragDiv.clientWidth - that.$refs.moveDiv.clientWidth
    document.getElementsByTagName('html')[0].addEventListener('mousemove', that.mouseMoveFn)
    document.getElementsByTagName('html')[0].addEventListener('mouseup', that.moseUpFn)
    //$("body").removeClass("no-skin");
    //$('body').attr('class', 'account-layout light-account');
    that.handleResize()
  },
  created() {
    let that = this
    that.handleResize()
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode === 13 && location.href.indexOf('/account') !== -1) {
        that.login() // 登录方法名
        return false
      }
    }

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize(event) {
      this.fullwidth = document.documentElement.clientWidth
      //页面宽度小于750px时，不显示地图
      if (this.fullwidth <= 980) {
        this.isShow = false
        this.confirmSuccess = true
      } else {
        this.isShow = true
        this.confirmSuccess = false
      }
    },

    mousedownFn: function (e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault() //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true
        this.beginClientX = e.clientX
      }
    }, //mousedoen 事件
    successFunction() {
      this.confirmSuccess = true
      this.confirmWords = '验证通过'
      if (window.addEventListener) {
        document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn)
        document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn)
      } else {
        document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => {})
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px'
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px'
    }, //验证成功函数
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        let width = e.clientX - this.beginClientX
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left = width + 'px'
          document.getElementsByClassName('drag_bg')[0].style.width = width + 'px'
        } else if (width > this.maxwidth) {
          this.successFunction()
        }
      }
    }, //mousemove事件
    moseUpFn(e) {
      this.mouseMoveStata = false
      var width = e.clientX - this.beginClientX
      if (width < this.maxwidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
      }
    },
    login() {
      let _this = this
      if (tools.Is_null(_this.account.account) === false || tools.Is_null(_this.account.password) === false) {
        this.$message.error('账户名或者密码不能为空！')
        return false
      }
      if (!this.confirmSuccess) {
        this.$message.error('请拖动滑块验证！')
        return false
      }
      _this.account.password = aesEncrypt(_this.account.password)
      _this.account.account = aesEncrypt(_this.account.account)
      _this.account.logUrl = aesEncrypt("getAccount")
      account( _this.account).then(res => {
        if (res.data.code === '0') {
          let data = JSON.parse(aesDecrypt(res.data.data))
          /*let sotype = data.sotype
          sessionStorage.setItem('sotype', sotype)*/
          let userToken = 'wtauth ' + data.token
          sessionStorage.setItem('sys-token', userToken)
          sessionStorage.setItem('loginUser', JSON.stringify(data.userAccount))
          sessionStorage.setItem('logUrl', JSON.stringify(data.logUrl))
          if('619285375'===data.userAccount.roleId){
            _this.$router.push({
              path: 'welcome2'
            })
          }else{
            _this.$router.push({
              path: 'welcome'
            })
          }

        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bck {
  background-image: url('../static/img/login.jpg');
  background-attachment: fixed;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  width: 100%;
  height: 100%;
}

/deep/ .el-main {
  text-align: left;
  /*padding: 20px !important;*/
  overflow: hidden !important;
}

/*.el-carousel__container{
        height: 570px;
    }*/

.logo_Span {
  font-size: 50px;
}

.span_card {
  height: 200px;
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  box-sizing: border-box;
  color: #666666;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-around;
    height: 100%;
  }

  .addBold {
    font-weight: bold;
    font-size: 17px;
  }

  .right {
    display: flex;
    align-items: center;
    flex-direction: column;

    justify-content: center;
    flex: 0.5;
    height: 100%;
    color: #ffffff;
    background: #00e2cb;
  }
}

.el-menu--horizontal > .el-menu-item {
  color: #ffffff;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #ffffff;
}

/** {
        margin: 0px;
        padding: 0px;
    }*/

/*.el-main, .el-header {
        padding: 0px;
    }*/

.float_right {
  float: right !important;
}

.right_herd {
  width: 60%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/*===================================*/
.drag {
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.handler {
  width: 40px;
  height: 40px;

  border: 1px solid #ccc;
  cursor: move;
}

.handler_bg {
  background: #fff
    url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==')
    no-repeat center;
}

.handler_ok_bg {
  background: #fff
    url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==')
    no-repeat center;
}

.drag_bg {
  background-color: #7ac23c;
  height: 40px;
  width: 0px;
}

.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}

.position-relative {
  position: absolute;
  top: 185px;
  right: 8%;
  z-index: 99;

  .login {
    box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    min-width: 350px;
    padding: 30px;
    padding-top: 40px;
    background-color: aliceblue;
  }
}

.el-input {
  height: 45px;
  background: transparent;

  input {
    padding-left: 10px;
    background: transparent;
  }
}

/deep/ .el-input__inner {
  height: 100%;
  background: transparent;
  border: 1px solid #3c618e;
  /*color: #ffffff;*/
}

/deep/ .el-form-item__content {
  line-height: 45px;
}

/deep/ .el-input__suffix {
  right: 20px;
}

/deep/ .el-menu--horizontal {
  border: none;
  padding: 0 20px;
}
</style>
